import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
} from '@mui/material';

export default function FAQ() {
  const faqs = [
    {
      q: 'Is this a lottery or gambling in disguise?',
      a: 'No. Every deal on iSoret shows its exact assured cashback percentage and payout amount before you buy the card. The reward is determined through iSoret\'s reward mechanism at the time of redemption — what\'s published is what you get on redemption.',
    },
    {
      q: 'How fast does cashback actually land?',
      a: 'All coupon cashback amounts are settled within 48 hours. Every redemption creates a ledger entry immediately, even while it\'s pending.',
    },
    {
      q: 'Can I use one card across multiple brands?',
      a: 'Yes — a coupon card is a season pass to every live deal within your tier, not a single-use voucher. Redeem as many listed deals as you like until the card\'s validity period ends.',
    },
    {
      q: 'What happens if a brand deal expires before I use it?',
      a: 'Expired deals simply drop off the live grid; your card itself stays valid for its full term and keeps unlocking new deals as they\'re added.',
    },
    {
      q: 'Do you sell or share my wallet data?',
      a: 'No. Card and wallet data are used only to process your redemptions and payouts, and are never sold to third parties.',
    },
  ];

  const [openIdx, setOpenIdx] = useState(null);

  const toggleFAQ = (idx) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <Box
      component="section"
      id="faq"
      sx={{
        padding: '80px 0',
        background: 'transparent',
        position: 'relative',
        textAlign: 'left',
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box
          sx={{
            textAlign: 'center',
            maxWidth: '640px',
            margin: '0 auto 56px auto',
          }}
        >
          <Typography
            sx={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '13px',
              color: '#E8C078',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            FAQ
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontFamily: '"Fraunces", serif',
              fontWeight: 700,
              fontSize: { xs: '32px', md: '40px' },
              color: '#F5F1E6',
              marginTop: '14px',
            }}
          >
            Frequently asked questions
          </Typography>
        </Box>

        {/* FAQ List */}
        <Box
          sx={{
            maxWidth: '760px',
            margin: '0 auto',
            width: '100%',
          }}
        >
          {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <Box
                key={idx}
                sx={{
                  borderBottom: '1px solid rgba(245, 241, 230, 0.14)',
                }}
              >
                {/* Question Accordion Button */}
                <Box
                  component="button"
                  onClick={() => toggleFAQ(idx)}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '22px 4px',
                    fontSize: '16px',
                    fontWeight: 600,
                    color: '#F5F1E6',
                    textAlign: 'left',
                    background: 'none',
                    border: 'none',
                    outline: 'none',
                    cursor: 'pointer',
                    fontFamily: '"Inter", sans-serif',
                  }}
                >
                  <span>{faq.q}</span>
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"JetBrains Mono", monospace',
                      fontSize: '18px',
                      color: '#E8C078',
                      transition: 'transform 0.25s',
                      transform: isOpen ? 'rotate(45deg)' : 'none',
                      marginLeft: '16px',
                      flexShrink: 0,
                    }}
                  >
                    +
                  </Box>
                </Box>

                {/* Answer Content */}
                <Box
                  sx={{
                    maxHeight: isOpen ? '200px' : '0px',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease',
                  }}
                >
                  <Typography
                    sx={{
                      padding: '0 4px 22px',
                      color: 'rgba(245, 241, 230, 0.66)',
                      fontSize: '14.5px',
                      maxWidth: '640px',
                      lineHeight: 1.6,
                    }}
                  >
                    {faq.a}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
}
